"use client";

import React from "react";
import { Clock, Shield, Tag } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  id: "price",
  title: "Institutional Investors / Family Offices",
  description: "Providing robust asset allocation solutions and diversified portfolio management for top-tier global capital to ensure sustainable long-term value growth."
}, {
  id: "insurance",
  title: "High-Growth Companies / Brands",
  description: "Empowering high-potential enterprises through capital infusion and strategic resource matching to achieve leapfrog growth and build international influence."
}, {
  id: "time",
  title: "High-Net-Worth Individuals",
  description: "Offering customized wealth management and asset allocation advice to protect and grow your wealth in a complex and ever-changing global market."
}];
export default function WhyWartmannUmzuege() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222589" id="Who We Create Value For" className="dark bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-widest mb-6 text-secondary-foreground">
            Who We Create Value For
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-default">
            STI Group is committed to providing global partners with comprehensive strategic support and capital empowerment through the dual engines of capital and innovation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, i) => {
          const Icon = feature.id === "price" ? Tag : feature.id === "insurance" ? Shield : Clock;
          return <div key={feature.id} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100}`} style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(32px)",
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="h-full border-border bg-card/50 backdrop-blur-sm shadow-lg hover:shadow-primary/20 hover:-translate-y-2 transition-all duration-300 group">
                  <CardHeader className="pb-4">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-300 !text-[rgba(255,255,255,1)] bg-secondary-foreground">
                      <Icon className="w-7 h-7 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-xl md:text-2xl text-foreground font-semibold">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground leading-relaxed font-default">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}